import { isAdmin } from "@/services/auth.service";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/settings/_admin")({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    if (!isAdmin(context.user))
      throw redirect({
        to: "/settings/profile",
      });
  },
});

function RouteComponent() {
  return <Outlet />;
}
